<template>
    <!-- 登录 -->
    <div class="logins">
        <div class="logleft">
            <img :src="$img(txt)" alt="" />
        </div>
        <div class="logContent">
            <!-- 【页面最外层放假输入框，欺骗Chrome】 -->
            <input type="text" style="position:absolute;opacity:0;width:0;height:0;" tabindex="-1">
            <input type="password" style="position:absolute;opacity:0;width:0;height:0;" tabindex="-1">

            <div class="gb flx alc" @click="toIndex">
                <span>返回首页</span>
            </div>
            <div>
                <!-- 登录方式切换 -->
                <div class="changeMetohds jsc flx alc">
                    <div class="cmItem" @click.stop="cur = 1,nelog()">
                        <div class="cmName" style="font-weight: bold !important;margin-bottom: 20px;"
                            v-text="cur == 2?'个人密码登录':cur == 1?'个人微信授权登录' : '个人验证码登录'" :class="cur < 4?'cmActive' : ''">
                        </div>
                    </div>
                </div>
                <div class="logtips flx alc jsc">
                    <img :src="$Localimg('xiaolaba.png')" alt="" />
                    <span>推荐使用：360、Q Q、谷歌等浏览器体验更好</span>
                </div>
                <!-- 个人扫码登录 -->
                <div class="saoma" v-if="cur == 1">
                    <!-- <div id="qrcodes" v-show="cur == 1" style="transform: scale(0.9);"></div> -->
                    <div style="height: 300px;line-height: 300px;">系统升级中...</div>
                    <div class="otherMethods">
                        <div class="otherTitle flx alc jsc">
                            <div class="otleft"></div>
                            <div class="otname">
                                其他方式登录
                            </div>
                            <div class="otright"></div>
                        </div>
                    </div>
                    <div class="permethods flx alc jsc">
                        <div class="peitem cursor" style="margin-right: 15px;" @click.stop="cur = 3">
                            <img :src="$Localimg('codever.png')" alt="" />
                            <div>
                                验证码登录
                            </div>
                        </div>
                        <div class="peitem cursor" @click.stop="cur = 2">
                            <img :src="$Localimg('pwdver.png')" alt="" />
                            <div>
                                密码登录
                            </div>
                        </div>
                    </div>
                    <div class="sarule">
                        扫码即同意 <b class="cursor" style="color:#007AFF" @click="toRule(2)">《隐私政策》</b> 和 <b class="cursor"
                            style="color:#007AFF" @click="toRule(1)">《用户协议》</b>
                    </div>
                </div>
            </div>
            <!-- 个人账号【密码登录】 cur=2 -->
            <div class="pzhanghao" v-if="cur == 2">
                <div class="plItem flx alc">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <input 
                            type="text" 
                            name="person_login_phone_01"
                            autocomplete="new-username"
                            autofill="off"
                            placeholder="请输入手机号码" 
                            maxlength="11" 
                            v-model="phone"
                            :readonly="isReadonly"
                            @focus="isReadonly=false"
                        />
                    </div>
                </div>
                <div class="plItem flx alc" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('locaIcon.png')" alt="" />
                        <input 
                            :type="inpType" 
                            name="person_login_pwd_01"
                            autocomplete="new-password"
                            autofill="off"
                            placeholder="请输入密码" 
                            maxlength="11" 
                            v-model="pwd"
                            :readonly="isReadonly"
                            @focus="isReadonly=false"
                        />
                        <img class="eyes" :src="$Localimg('eyeIcon.png')" v-if="inpType == 'password'"
                            @click="inpType = 'text'" alt="">
                        <img class="eyes" :src="$Localimg('openeye.png')" v-if="inpType == 'text'"
                            @click="inpType = 'password'" alt="">
                    </div>
                </div>
                <div class="flx alc rever">
                    <span class="bword" @click="forgets">忘记密码</span> <span class="sh">丨</span> <span
                        @click="freeregister" class="bword">免费注册</span>
                </div>
                <div class="Loginbtn cursor" @click="smlogs(1)">
                    立即登录
                </div>
                <div class="otherMethods">
                    <div class="otherTitle flx alc jsc">
                        <div class="otleft">
                        </div>
                        <div class="otname">
                            其他方式登录
                        </div>
                        <div class="otright">
                        </div>
                    </div>
                </div>
                <div class="wechatlogin flx alc jsc">
                    <div class="peitem pointer" style="margin-right: 15px;" @click="cur = 1,nelog()">
                        <img :src="$Localimg('wechat.png')" alt="" />
                        <div>
                            微信登录
                        </div>
                    </div>
                    <div class="peitem cursor" @click.stop="cur = 3">
                        <img :src="$Localimg('codever.png')" alt="" />
                        <div>
                            验证码登录
                        </div>
                    </div>
                </div>
                <div class="rules flx alc jsc" style="margin-top: 30px;">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="toRule(2)">《隐私政策》</b> 和 <b
                            class="cursor" style="color:#007AFF" @click="toRule(1)">《用户协议》</b>
                    </div>
                </div>
            </div>
            <!-- 个人账号【验证码登录】 cur=3 -->
            <div class="pzhanghao" v-if="cur == 3">
                <div class="plItem flx alc">
                    <div class="phoneInp flx alc jsb">
                        <img :src="$Localimg('phoneIcon.png')" alt="" />
                        <input 
                            type="text" 
                            name="person_code_phone_01"
                            autocomplete="new-username"
                            autofill="off"
                            placeholder="请输入手机号码" 
                            maxlength="11" 
                            v-model="phone"
                            :readonly="isReadonly"
                            @focus="isReadonly=false"
                        />
                    </div>
                </div>
                <div class="plItem flx alc jsb" style="margin-top: 30px;">
                    <div class="phoneInp flx alc jsb" style="width: 245px;">
                        <img :src="$Localimg('gurdIcon.png')" alt="" />
                        <input 
                            type="text" 
                            name="person_code_val_01"
                            autocomplete="one-time-code"
                            autofill="off"
                            placeholder="请输入短信验证码" 
                            maxlength="6" 
                            v-model="code"
                            :readonly="isReadonly"
                            @focus="isReadonly=false"
                        />
                    </div>
                    <div class="sendCode cursor" @click="sendCode">
                        {{ isCountDown ? `${count} 秒后重发` : '获取验证码' }}
                    </div>
                </div>
                <div class="Loginbtn cursor" @click="sylogs(1)">
                    立即登录
                </div>
                <div class="otherMethods">
                    <div class="otherTitle flx alc jsc">
                        <div class="otleft"></div>
                        <div class="otname">
                            其他方式登录
                        </div>
                        <div class="otright"></div>
                    </div>
                </div>
                <div class="wechatlogin flx alc jsc">
                    <div class="peitem pointer" style="margin-right: 15px;" @click="cur = 1,nelog()">
                        <img :src="$Localimg('wechat.png')" alt="" />
                        <div>
                            微信登录
                        </div>
                    </div>
                    <div class="peitem cursor" @click.stop="cur = 2">
                        <img :src="$Localimg('pwdver.png')" alt="" />
                        <div>
                            密码登录
                        </div>
                    </div>
                </div>
                <div class="rules flx alc jsc" style="margin-top: 30px;">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="toRule(2)">《隐私政策》</b> 和 <b
                            class="cursor" style="color:#007AFF" @click="toRule(1)">《用户协议》</b>
                    </div>
                </div>
            </div>
        </div>
        <div v-text="ttp" @click="toJump" class="ttp cursor"></div>
    </div>
</template>


<script>
    import {
        getConfig,
        sendCode,
        phoneLogin,
        codeLogin,
        userInfo,
        smlogin,
        sylogin
    } from "@/api/index.js"
    export default {
        name: 'Login',
        data() {
            return {
                isReadonly:true, //新增这一行
                showLogin: false,
                inpType: "password",
                logo: "",
                cur: 2,
                phone: "",
                codeTxct: "获取验证码",
                code: "",
                sending: false,
                hasRead: false,
                isCountDown: false, // 是否正在倒计时
                count: 60, // 倒计时秒数
                timer: null, // 定时器
                pwd: "",
                show: false,
                isLogin: false,
                qrcode: "",
                txt: "",
                ttp: ""
            }
        },
        mounted() {
            // this.nelog()
            let that = this
            getConfig().then((res) => {
                if (res.code == 1) {
                    that.txt = res.data.bg_login_text
                    that.ttp = res.data.beian
                }
            })
        },
        methods: {
            freeregister() {
                this.$emit("regis", this.cur)
            },
            forgets() {
                this.$emit("forgets", this.cur)
            },
            smlogs(e) {
                let that = this
                if (that.hasRead == false) {
                    that.$message.warning('请勾选并仔细阅读《隐私政策》和《用户协议》')
                    return
                }
                let data = {}
                data.tel = that.phone
                data.pwd = that.pwd
                data.type = e
                smlogin(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.show = false
                        if (e == 1) {
                            localStorage.setItem('token', res.data.token)
                            history.go(0)
                        } else {
                            localStorage.setItem('token', res.data.token)
                            that.$router.push({
                                path: '/shopIndex'
                            })
                        }


                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            toJump() {
                window.open('https://beian.miit.gov.cn/#/Integrated/index')
            },
            sylogs(e) {
                let that = this
                if (that.hasRead == false) {
                    that.$message.warning('请勾选并仔细阅读《隐私政策》和《用户协议》')
                    return
                }
                let data = {}
                data.tel = that.phone
                data.code = that.code
                data.type = e
                sylogin(data).then((res) => {
                    if (res.code == 1) {
                        that.show = false
                        that.$message.success(res.msg)
                        if (e == 1) {
                            localStorage.setItem('token', res.data.token)
                            history.go(0)
                        } else {
                            localStorage.setItem('token', res.data.token)
                            that.$router.push({
                                path: '/shopIndex'
                            })
                        }
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            // nelog() {
            //     setTimeout(() => {
            //         new window.WxLogin({
            //             self_redirect: false,
            //             id: "qrcodes",
            //             appid: "wx039fe18cba88e30f",
            //             scope: "snsapi_login",
            //             redirect_uri: encodeURIComponent("https://hrxsl.com/getCode"),
            //             state: "logs",
            //             style: "black",
            //             href: "",
            //             onReady: function(isReady) {
            //                 console.log(isReady);
            //             }
            //         });
            //     }, 500)
            // },
            closedo() {
                this.$emit("cal", 1)
            },

            // toRule(e) {
            //     this.closedo()
            //     this.$router.push({
            //         path: '/rules', // 写路由path
            //         query: {
            //             type: e,
            //             t: Date.now()
            //         }
            //     })
            // },
            toRule(e) {
                window.open('https://hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },

            // 登录
            toLogin() {
                let that = this
                let data = {}
                data.tel = that.phone
                data.pwd = that.pwd
                data.code = that.code
                if (that.hasRead == false) {
                    that.$message.warning('请勾选并仔细阅读《隐私政策》和《用户协议》')
                    return
                }
                if (that.cur == 0) {
                    phoneLogin(data).then((res) => {
                        if (res.code == 1) {
                            that.$message.success(res.msg)
                            localStorage.setItem('token', res.data.token)
                            localStorage.setItem('user_id', res.data.user_id)
                            that.show = false
                            that.$emit("logsuccess")
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
                } else {
                    codeLogin(data).then((res) => {
                        if (res.code == 1) {
                            that.$message.success(res.msg)
                            localStorage.setItem('token', res.data.token)
                            localStorage.setItem('user_id', res.data.user_id)
                            that.show = false
                            that.$emit("logsuccess")
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
                }
            },
            toIndex() {
                window.location.href = "https://hrxsl.com"
            },
            // 发送验证码
            sendCode() {
                let that = this
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.phone)
                if (this.isCountDown == false) {
                    let data = {}
                    data.tel = that.phone
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown = true
                            let time = this.count
                            this.timer = setInterval(() => {
                                time--
                                this.count = time
                                if (time <= 0) {
                                    clearInterval(this.timer)
                                    this.isCountDown = false
                                    this.count = 60
                                }
                            }, 1000)
                            this.$message.success('验证码已发送')
                        } else {
                            that.$message.error(res.msg)
                        }
                    })

                }
            },
        }
    }
</script>
<style scoped>
    .gb {
        color: #007AFF;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: -30px;
    }

    .ttp {
        position: absolute;
        bottom: 40px;
        text-align: center;
        width: 100%;
        color: #999;
        font-size: 14px;
    }

    .logleft {
        position: absolute;
        left: 15%;
        top: 40%;
        transform: translateY(-50%);
        width: 40%;
    }

    .logleft img {
        width: 100%;
        height: auto;
    }

    .sh {
        color: #BEBEBE;
        font-size: 12px;
        margin: 0 12px;
    }

    .wechatlogin {
        margin-top: 18px;
    }

    .bword {
        font-weight: 500;
        font-size: 14px;
        color: #007AFF;
        cursor: pointer;
    }

    .rever {
        text-align: right;
        flex-direction: row-reverse;
        margin-top: 16px;
    }

    .pzhanghao {
        margin-top: 16px;
    }

    .pztitle {
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        margin-bottom: 12px;
    }

    .sarule {
        margin-top: 27px;
        font-size: 12px;
        color: #333;
    }

    .permethods {
        margin: 20px auto 0;
        box-sizing: border-box;
        padding: 0 54px;
    }

    .peitem img {
        width: 30px;
        height: 30px;
        margin-bottom: 8px;
    }

    .peitem {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .otname {
        margin: 0 24px;
        font-weight: 600;
        font-size: 12px;
        color: #73829D;
    }

    .otleft,
    .otright {
        width: 94px;
        height: 1px;
        background: #E9E9E9;
    }

    .regi {
        text-align: center;
        font-size: 12px;
        color: #007AFF;
        margin-top: 70px;
    }

    .logtips img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
    }

    .logtips {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .wechat {
        margin-top: 40px;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
    }

    .wechat img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .Loginbtn {
        margin-bottom: 20px;
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 63px;
    }

    .sendCode {
        width: 91px;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 12px;
        color: #666666;
        font-weight: 500;
    }

    .phoneInp img {
        width: 18px;
        height: 18px;
    }

    .phoneInp input {
        flex: 1;
        box-sizing: border-box;
        padding: 0 8px;
        height: 100%;
        font-size: 14px;
        border: none !important;
        outline: none !important;
        background: transparent !important;
    }

    .phoneInp {
        width: 100%;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .phoneLogin {
        margin-top: 50px;
    }

    .cmActive {
        font-weight: 500 !important;
        font-size: 20px !important;
        color: #007AFF !important;
    }

    .heng {
        width: 32px;
        height: 3px;
        background: #007AFF;
        border-radius: 2px;
        margin: 10px auto 0;
    }

    .changeMetohds {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cmName {
        font-weight: 500;
        font-size: 20px;
        color: #999999;
    }

    .cmItem {
        margin: 0 24px;
        cursor: pointer;
    }

    .closeBtn {
        position: absolute;
        right: -50px;
        top: 0;
        cursor: pointer;
    }

    .logMethod img {
        width: 100%;
        height: 100%;
    }

    .logMethod {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 55px;
        height: 55px;
    }

    .logContent {
        width: 25%;
        /* height: 711px; */
        background: #fff;
        position: absolute;
        right: 5%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        box-sizing: border-box;
        padding: 30px;
    }

    .logins {
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background-color: #fff;
        background: url('https://shop.hrxsl.com/images/loginback.png') no-repeat;
        background-size: 100% 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1166 !important;
    }

    .el-submenu__title:hover {
        background: transparent !important;
    }

    .el-menu--popup-bottom-start {
        margin-top: 0 !important;
    }

    .el-menu--popup {
        padding: 0 !important;
    }

    .el-menu--horizontal>.el-menu-item.is-active {
        border: none !important;
    }

    .el-menu {
        background-color: transparent !important;
    }

    .pubItem {
        font-weight: 500;
        font-size: 16px;
        color: #151515;
        padding: 0 24px;
        cursor: pointer;
    }

    .el-header {
        padding: 0 !important;
    }

    .register {
        width: 83px;
        height: 115px;
        background: #007AFF;
        text-align: center;
        line-height: 115px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 115px;
        cursor: pointer;
    }

    .shu {
        width: 1px;
        height: 14px;
        background: #D9D9D9;
    }

    .pubs {
        flex: 1;
        justify-content: flex-end;
    }

    .search {
        margin-left: 259px;
    }

    .inp {
        width: 344px;
        height: 34px;
        border: 1px solid #007AFF;
    }

    .inp input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 13px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .searchBtn {
        width: 86px;
        height: 34px;
        background: #007AFF;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        font-size: 13px;
        color: #FFFFFF;
    }

    .hea {
        background: pink;
        height: 115px !important;
        background: #FFFFFF;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 230px !important;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        width: 100%;
    }

    .logo {
        width: 162px;
        height: 55px;

    }

    .logo img {
        width: 100%;
        height: 100%;
    }
    
    /* 清除浏览器自动填充黄色背景 */
    .phoneInp input:-webkit-autofill,
    .phoneInp input:-webkit-autofill:hover,
    .phoneInp input:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0px 1000px #F6F7F9 inset !important;
      -webkit-text-fill-color: #333 !important;
      transition: background-color 9999s ease-in-out 0s;
    }
</style>